export const config = {
  apiKey: "AIzaSyAxbbWFYTXbFKXQQRpxijtE_qZXCXCF6oM",
  authDomain: "gigodhet.firebaseapp.com",
  databaseURL: "https://gigodhet.firebaseio.com",
  projectId: "gigodhet",
  storageBucket: "gigodhet.appspot.com",
  messagingSenderId: "451270037425",
  appId: "1:451270037425:web:2aa4c40a3f3c9251"
};